import { API_BASE_URL, FAILURE, POST, GET, SUCCESS } from "../utils/const/http-const";
import { getHeaders } from "./utils";

export async function createConfiguracionExcelImportarTipoVehiculo(obj) {
    try {
        let data = { error: true };
        const { code } = await fetch(
            API_BASE_URL + "/configurar-importar-excel-tipo-vehiculo/create-configuracion-importar-excel-tipo-vehiculo",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            // data.error = false;
            data.error = false;
        }
        return data;
    } catch (err) {
        console.log("createConfiguracionExcelImportarTipoVehiculo err");
        console.log(err);
        return { error: true };
    }
}

export async function obtenerConfiguracionExcelImportarTipoVehiculo() {
    try {
        let data = { error: true };
        const { code, message, body } = await fetch(
            API_BASE_URL + "/configurar-importar-excel-tipo-vehiculo/obtener-configuracion-importar-excel-tipo-vehiculo",
            {
                headers: getHeaders(),
                method: GET,
                // body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
            if (Array.isArray(body) === true && body.length > 0) {
                data.body = body[0];
            } else {
                data.body = null;
            }
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("obtenerConfiguracionExcelImportarTipoVehiculo err");
        console.log(err);
        return { error: true, message: err };
    }
}

export async function actualizarConfiguracionExcelImportarTipoVehiculo(obj) {
    try {
        let data = { error: true };
        const { code, message } = await fetch(
            API_BASE_URL + "/configurar-importar-excel-tipo-vehiculo/actualizar-configuracion-importar-excel-tipo-vehiculo",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("actualizarConfiguracionExcelImportarTipoVehiculo err");
        console.log(err);
        return { error: true, message: err };
    }
}

export async function guardarImportarExcelTipoVehiculo(obj) {
    try {
        let data = { error: true };
        const { code, message } = await fetch(
            API_BASE_URL + "/configurar-importar-excel-tipo-vehiculo/guardar-importar-excel-tipo-vehiculo",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("guardarImportarExcelTipoVehiculo err");
        console.log(err);
        return { error: true, message: err };
    }
}
